
const state = {
  direction: "forward",
  loading: false,
}

const mutations = {
  UPDATE_DIRECTION: (state, direction) => {
    state.direction = direction
  },
  UPDATE_LOADING: (state, loading) => {
    state.loading = loading
  }
}

const actions = {
}

export default {
  state,
  mutations,
  actions
}

